/**
 * Desktop: pin mod1 after its content has scrolled, then let block2 scroll up
 * naturally to cover the pinned view. Mobile and reduced-motion keep document flow.
 */
(function () {
  "use strict";

  const ROOT_SELECTOR = "[data-dop-bdm]";
  const MOD1_SELECTOR = "[data-dop-bdm-mod1]";
  const BLOCK2_SELECTOR = "[data-dop-bdm-block2]";
  const DESKTOP_QUERY = "(min-width: 721px)";

  const mmMap = new WeakMap();

  function destroyRoot(root) {
    const mm = mmMap.get(root);
    if (mm) {
      mm.revert();
      mmMap.delete(root);
    }

    root.removeAttribute("data-dop-bdm-ready");
  }

  function initRoot(root) {
    if (typeof gsap === "undefined" || typeof ScrollTrigger === "undefined") {
      return;
    }

    const mod1 = root.querySelector(MOD1_SELECTOR);
    const block2 = root.querySelector(BLOCK2_SELECTOR);

    if (!mod1 || !block2) {
      return;
    }

    destroyRoot(root);
    gsap.registerPlugin(ScrollTrigger);

    const mm = gsap.matchMedia();

    mm.add(
      {
        isDesktop: DESKTOP_QUERY,
        reduceMotion: "(prefers-reduced-motion: reduce)",
      },
      (context) => {
        const { isDesktop, reduceMotion } = context.conditions;

        if (!isDesktop || reduceMotion) {
          return;
        }

        const pinSt = ScrollTrigger.create({
          trigger: mod1,
          start: "bottom bottom",
          endTrigger: block2,
          end: "top top",
          pin: true,
          pinSpacing: false,
          markers: false,
          anticipatePin: 1,
          invalidateOnRefresh: true,
        });

        root.setAttribute("data-dop-bdm-ready", "");

        return () => {
          pinSt.kill();
          root.removeAttribute("data-dop-bdm-ready");
        };
      },
      root
    );

    mmMap.set(root, mm);
    ScrollTrigger.refresh();
  }

  function initAll(scope = document) {
    scope.querySelectorAll(ROOT_SELECTOR).forEach((root) => initRoot(root));
  }

  function refreshTriggers() {
    if (typeof ScrollTrigger !== "undefined") {
      ScrollTrigger.refresh();
    }
  }

  function onPageHide() {
    document.querySelectorAll(ROOT_SELECTOR).forEach((root) => destroyRoot(root));
    window.removeEventListener("load", refreshTriggers);
    window.removeEventListener("pagehide", onPageHide);
  }

  function bootstrap() {
    initAll();
    window.addEventListener("load", refreshTriggers, { once: true });
    window.addEventListener("pagehide", onPageHide);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", bootstrap, { once: true });
  } else {
    bootstrap();
  }

  document.addEventListener("shopify:section:load", (event) => {
    const root = event.target.querySelector(ROOT_SELECTOR);
    if (!root) {
      return;
    }

    initRoot(root);
    refreshTriggers();
  });

  document.addEventListener("shopify:section:unload", (event) => {
    const root = event.target.querySelector(ROOT_SELECTOR);
    if (root) {
      destroyRoot(root);
    }
  });
})();
